var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: 'fields', base: '_parent', prototype: {
    element_selector: 'fieldset, .fields, .sheets',

    init: function (params) {
      xP.controls.fields.base.init.apply(this, arguments);

      var id = this.$element.attr('id');

      if (!this.$label && id) {
        this.$label = $("[for='" + xP.taint_css(id) + "']");
      }
    },

    count: function () {
      if (this.disabled || !this.children().length) {
        return undefined;
      }

      var result = 0;

      this.children().each(function () {
        if (this instanceof xP.controls.fields) {
          if (this.val()) {
            result++;
          }
        } else if (this.val() != '') {
          result++;
        }
      });

      return result;
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/fields.js
 ** module id = 16
 ** module chunks = 0
 **/